var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 96,
    viewBox: "0 0 110 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6302 50.1244C63.5898 50.1244 74.9063 38.9037 74.9063 25.0622C74.9063 11.2207 63.5898 0 49.6302 0C35.6706 0 24.354 11.2207 24.354 25.0622C24.354 38.9037 35.6706 50.1244 49.6302 50.1244Z",
    fill: "#E22A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5227 56.5782C60.9122 62.0101 59.7189 67.5496 59.7189 75.1866C59.7189 80.6185 63.3531 86.7496 63.3531 86.7496H0V86.4807C0 68.3563 14.8077 53.6202 33.141 53.6202H60.641C63.0276 53.6202 65.9566 53.6202 67.5838 54.3193C66.8245 55.0723 66.1736 55.8252 65.5227 56.5782Z",
    fill: "#E22A27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.769 59.8588C104.467 58.0303 102.894 56.4168 101.159 55.0185C97.2535 51.9529 92.2633 50.1244 86.8935 50.1244C79.7337 50.1244 73.3876 53.3513 69.1026 58.4067C65.7396 62.3866 63.7327 67.4958 63.7327 73.0891C63.7327 75.4017 64.0582 77.6067 64.7091 79.7042C64.8718 80.2958 65.0888 80.8336 65.3057 81.3714C65.6854 82.3933 66.1736 83.3613 66.716 84.2756C70.6755 91.2672 78.215 96 86.8935 96C99.64 96 110 85.7277 110 73.0891C110 68.1412 108.427 63.5698 105.769 59.8588ZM82.9339 85.1361L72.6824 74.9714L77.1302 70.5613L82.9339 76.316L96.4941 62.8706L100.942 67.2807L82.9339 85.1361Z",
    fill: "#EF5756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChecked);
export default __webpack_public_path__ + "static/media/userChecked.c5584624cd436ea1842ec4de70a96441.svg";
export { ForwardRef as ReactComponent };